import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import HttpBackend from 'i18next-http-backend';
import { defaultLanguage, languageCodes } from './languages';
import { brandTerms } from './brandTerms';

// Initialize i18next
i18n
  .use(HttpBackend)
  .use(initReactI18next)
  .init({
    // Site is English-first. SV is only activated on the two SV-authored
    // pages (/sv/ai-agenter, /sv/ai-medarbetare), which call
    // i18n.changeLanguage('sv') on mount.
    supportedLngs: languageCodes,
    lng: 'en',
    fallbackLng: 'en',

    // Default namespace
    defaultNS: 'common',
    ns: ['common', 'home', 'tour', 'about', 'faq', 'meta', 'promptAnalyzer', 'contact', 'algorithmHotel', 'careers', 'blick', 'privacy', 'euAiAct', 'aiAdvantageLab', 'aiAgents', 'aiEmployees', 'privateEquity'],

    // Backend configuration for loading translation files
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
    },

    // Interpolation configuration
    interpolation: {
      escapeValue: false, // React already escapes
      // Default variables available in all translations
      defaultVariables: brandTerms,
    },

    // React specific configuration
    react: {
      useSuspense: true,
      bindI18n: 'languageChanged loaded',
      bindI18nStore: 'added removed',
    },

    // Debug mode in development
    debug: import.meta.env.DEV,

    // Return key if translation missing (helps identify missing translations)
    returnEmptyString: false,
    returnNull: false,
  });

